import { useLayoutEffect, useState } from 'react';
import { imageFocalPointPosition, normalizeImageFocalPoint } from './imageFocalPoint';

export function useImageFocalPoint(src, point, mediaFit) {
  const [image, setImage] = useState(null);
  const [position, setPosition] = useState(undefined);
  const focal = normalizeImageFocalPoint(point);
  const x = focal?.x;
  const y = focal?.y;
  const enabled = !!focal && mediaFit !== 'contain';

  useLayoutEffect(() => {
    if (!enabled || !image) return undefined;
    const update = () => setPosition(imageFocalPointPosition(
      { x, y },
      { width: image.clientWidth, height: image.clientHeight },
      { width: image.naturalWidth, height: image.naturalHeight },
    ));
    const observer = new ResizeObserver(update);
    observer.observe(image);
    image.addEventListener('load', update);
    update();
    return () => {
      observer.disconnect();
      image.removeEventListener('load', update);
    };
  }, [image, src, enabled, x, y]);

  return { ref: enabled ? setImage : undefined, objectPosition: enabled ? position : undefined };
}
